import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable()
export class SpinnerService {
  constructor() {}

  loading() {
    return Swal.fire({
      html: `<svg class="overflow-hidden spinner-DW" viewBox="0 0 50 50"><circle class="path-back" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle></svg>`,
      allowOutsideClick: false,
      customClass: {
        popup: "spinner-container-DW",
        actions: "d-none"
      },
      didOpen: function () {
        Swal.showLoading();
      }
    })
  }

  close () {
    Swal.close();
  }
}